import { useEffect } from 'react';

import { Pharmacy } from '~entities/pharmacy';
import { Profile } from '~entities/session';
import {
  bootIntercom,
  disableIntercom,
  shutdownIntercom,
  useGetIntercomJWT,
} from '~shared/intercom';

type UseIntercomInitProps = {
  profile: Profile | undefined;
  pharmacy: Pharmacy | undefined;
};

export const useIntercomInit = ({
  profile,
  pharmacy,
}: UseIntercomInitProps) => {
  const sentName = `${profile?.firstName || ''} ${profile?.lastName || ''}`;
  const isPharmabestEs = pharmacy?.isPharmabestEs;
  const jwtParams = isPharmabestEs
    ? undefined
    : {
        pharmacyId: pharmacy?.id || '',
        name: sentName,
        email: profile?.email,
        role: profile?.info.role,
      };
  const { intercomJWT } = useGetIntercomJWT(jwtParams);

  const shouldInitIntercom = profile && pharmacy && intercomJWT;

  useEffect(() => {
    if (!isPharmabestEs) {
      return;
    }

    disableIntercom();

    return () => {
      shutdownIntercom();
    };
  }, [isPharmabestEs]);

  useEffect(() => {
    if (!shouldInitIntercom) {
      return;
    }

    bootIntercom({
      jwt: intercomJWT.jwtToken,
      name: sentName,
      email: profile.email,
      role: profile.info.role,
      company: {
        id: pharmacy.id,
        name: pharmacy.name,
        plan: pharmacy.pharmacyPlan,
        website: pharmacy.urlOpt,
      },
    });

    return () => {
      shutdownIntercom();
    };
  }, [intercomJWT, profile, pharmacy, sentName, shouldInitIntercom]);
};
